export default __webpack_public_path__ + "static/media/circle.24597bee.png";